import "antd/dist/antd.css";
import MenuBar from "./component/Menu/menu";
import Panel from "./component/Panel/panel";
import { MyContext } from "./component/utils/utils";
import { useState } from "react";
import Home from "./component/Home/home";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import { Routes, Route, BrowserRouter } from "react-router-dom";

import Game from "./component/Game/game";

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user) {
      setCurrentUser(user);
    } else {
      setCurrentUser(null);
    }
  });

  return (
    <MyContext.Provider value={{ currentUser, setCurrentUser }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact={true} element={<Home />} />
          <Route path="/game/:key" element={<Game />} />
        </Routes>
      </BrowserRouter>
    </MyContext.Provider>
  );
}

export default App;
